if (!customElements.get('floating-button')) {
  class FloatingButton extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    onScrollHandler () {
      this.rect = this.getBoundingClientRect();
      if (!this.settings.exit && this.settings.fixed && this.rect.y > -200) {
        this.settings.button.classList.add("removed");
        this.settings.button.classList.remove("fixed");
        this.settings.exit = true;
        this.settings.fixed = false;
        if (this.settings.exit) {
          setTimeout(() => {
            this.settings.button.classList.remove("removed");
            this.settings.exit = false;
          }, 500);
        }
      }
      else if (!this.settings.exit && !this.settings.fixed && this.rect.y < -200) {
        this.settings.button.classList.add("fixed");
        this.settings.fixed = true;
      }
    }

    init () {
      this.settings = {
        fixed: false,
        exit: false,
        button: this.querySelector(":scope > *")
      };
      window.addEventListener('scroll', this.onScrollHandler.bind(this), false);
    }
  }

  customElements.define('floating-button', FloatingButton);
}
